import { Header } from '@amway/react-components';
import { useCallback, useState } from 'react';
import { Environments } from '../../../@types/configuration';
import environment, { appTitle } from '../../../config/env';
import { Features } from '../../../config/features';
import { WithFeaturesProxy } from '../../../helpers/with-features-proxy';
import useAuth from '../../../resources/auth/auth-hook';
import PermissionsModal from './permissions-modal';

const shouldShowQaContainer = [Environments.DEV, Environments.QA].includes(environment.ENV);

interface ExposedProps {}

interface Props extends ExposedProps {
  onSettingsClick?: VoidFunction;
}

const NavBarComponent: React.FC<Props> = ({ onSettingsClick }) => {
  const { isAuthenticated, user } = useAuth();

  return (
    <Header
      isAuthenticated={isAuthenticated ?? false}
      shouldShowQaContainer={shouldShowQaContainer}
      title={appTitle}
      user={user}
      environment={environment.ENV}
      onSettingsClick={onSettingsClick}
      appVersion={import.meta.env.VITE_APP_VERSION ?? 'N/A'}
    />
  );
};

export default WithFeaturesProxy<ExposedProps>(Features.ManageOwnPermissions)((_, hasFeature) => {
  const [isQaModalOpen, setIsQaModalOpen] = useState(false);

  const handleOpenQaModal = useCallback(() => {
    setIsQaModalOpen(true);
  }, []);

  const handleCloseQaModal = useCallback(() => {
    setIsQaModalOpen(false);
  }, []);

  if (hasFeature) {
    return (
      <>
        <NavBarComponent onSettingsClick={handleOpenQaModal} />
        {/* TODO: Create PermissionModal inside Storybook */}
        <PermissionsModal isOpen={isQaModalOpen} onClose={handleCloseQaModal} />
      </>
    );
  }

  return <NavBarComponent />;
});
